/*
@file    index.jsx
@class   UserNotification

@author Carlos Sepúlveda. <csepulveda@atentus.com>
(c) Servicios de Monitoreo S.A. - Santiago, Chile

@brief  Componente destinado a las notifiaciones de usuario en el reporte
@date   Feb/2021

*/

import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

import { withRouter } from 'react-router-dom';
// Material helpers
import { withStyles } from '@material-ui/core/styles';
// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';

// Material components
import IconButton from '@material-ui/core/IconButton';
import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import Grid from '@material-ui/core/Grid';
import ClearIcon from '@material-ui/icons/Clear';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
// Component styles
import styles from './styles';
// local method
import {getUserNotifications} from "../../../../services/getUserNotifications";
import {createNotificationControl} from "../../../../services/createNotificationControl";

import moment from 'moment'
import 'moment/locale/es'
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import PerfectScrollbar from "react-perfect-scrollbar";
import Modal from "@material-ui/core/Modal";
moment.locale('es')

/*
@class UserNotification
@brief Componente notificaciones de reporte.
*/
class UserNotification extends Component {

    constructor(props) {
        super(props);
        this.handleOnclickPrevNotif = this.handleOnclickPrevNotif.bind(this);
        this.handleOnclickNextNotif = this.handleOnclickNextNotif.bind(this);
        this.handleChange = this.handleChange.bind(this)
        this.handleClose = this.handleClose.bind(this)

        this.state = {
            notifications:[],// notificaciones del usuario.
            notificationsId:[], // notificaciones id del usuario
            posNotific:0,// posicion de notificaciones en el arreglo.
            checked:false,// check de para no mostrar mas las notifiaciones.
            statusControl: null,// status de la peticion, 'no mostrar mas notificaciones.'
            title: '',// titulo notificacion
            typeNoti:'',// tipo de notificacion
            numberOfNotific: 0, // cantidad de notificaciones
            openModalNot: true

        };
    }
    /*
    @brief Método que permite ejecutar limpieza de intervalo, se ejecuta al desmontar el componente.
    */
    componentWillUnmount() {
        clearInterval(this.timerID);
    }
    /*
    @brief Método que permite  obtener las notificaciones del usuario
    */
    componentDidMount() {
        let token = sessionStorage.getItem('key')
        let idUser = sessionStorage.getItem('user')
        //let idUser = 7255
        let _notifications = []
        let _notificationsId = []
        // método que obtiene las notificaciones de usuario.
        getUserNotifications(token, idUser).then(data =>{
            Object.keys(data).map((index,val) => {
                // Organiza datos de notificacion para su iteración
                _notifications.push(data[index])
                // obtiene los id de las notificaciones obtenidas
                _notificationsId.push(data[index]["notificacion_id"])
            })
            // si no tiene notificaciones que mostrar cierra dialogo
            if (_notificationsId.length == 0){
                this.handleClose()
                return
            }
            // setea los estados de notificacion y ids notificacion
            this.setState({
                notifications: _notifications,
                notificationsId: _notificationsId,
                title: _notifications[0]["notificacion_titulo"],
                typeNoti: _notifications[0]["notificacion_tipo"]
            })
        })
    }
    /*
    @brief Método que permite cambiar a la notificacion anterior del  notificacion modal.
    */
    handleOnclickPrevNotif = () => {
        // indice de la notificacion siguiente
        const prevNot = this.state.posNotific - 1
        // si no existen notificaciones no setea estado.
        if (this.state.posNotific == 0){
            return
        }
        // estado para retroceder una notificacion
        this.setState({
            posNotific: prevNot,
            title: this.state.notifications[prevNot]["notificacion_titulo"],
            typeNoti: this.state.notifications[prevNot]["notificacion_tipo"]
        })
    }
    /*
    @brief Método que permite cambiar a la notificacion siguiente del  notificacion modal.
    */
    handleOnclickNextNotif = () => {
        // indice de la notificacion siguiente
        const nextNot = this.state.posNotific + 1
        // no realiza nada cuando tiene al menos una notificacion o ya esta en la ultima notificacion.
        if (this.state.notificationsId.length <= 1 || this.state.notificationsId.length == nextNot){
            return
        }
        this.setState({
            posNotific: nextNot,
            title: this.state.notifications[nextNot]["notificacion_titulo"],
            typeNoti: this.state.notifications[nextNot]["notificacion_tipo"]
        })
    }
    /*
    @brief Cambia el estado del checkbox
    */
    handleChange = () => {
        this.setState(prevState=>({
            checked: !prevState.checked
        }))
    }
    /*
    @brief envia petición a la api para desactivar una notificación.
    @param notificationId  .
    */
    dispatchSetShowNot = (notificationId) => {
        let token = sessionStorage.getItem('key')
        let idUser = sessionStorage.getItem('user')

        if (this.state.checked){
            createNotificationControl(this.state.notificationsId,idUser,token).then(data =>{
                this.handleClose()
            })
        }
        else{
            this.handleClose()
        }
    }
    /*
    @brief cerrar modal.
    @param notificationId  .
    */
    handleClose = event => {
        this.setState({
            openModalNot: false
        })
    };

    render() {

        const { classes, handleClose} = this.props;
        const {notifications,posNotific,checked,title,typeNoti,openModalNot} = this.state;
        const quantitynot = notifications.length
        // estilos de clases
        let classBackBut = {}
        let classNextBut = {}
        let htmlContent = null

        if (quantitynot === 0 || posNotific==0){
            classBackBut = {color: '#12161B', cursor: 'default'}
        }else{
            classBackBut = {color: '#f57000', cursor: 'pointer'}
        }
        // solo cuando existan mas notificaciones que mostrar despúes de la última.
        if (quantitynot > 1 && posNotific  + 1< quantitynot){
            classNextBut = {color: '#f57000', cursor: 'pointer'}
        }else{
            classNextBut = {color: '#12161B', cursor: 'default'}
        }

        // agrega el cuerpo html solo si encuentra notificaciones activas para el usuario.
        if (notifications.length > 0) {
            htmlContent = notifications[posNotific]["notificacion_cuerpo"]
            return (
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={openModalNot}
                    onClose={this.handleClose}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    closeAfterTransition
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={openModalNot}>
                        <PerfectScrollbar style={{position:"static"}}>
                            <div className={classes.div}>
                                <Portlet
                                    /*  {...rest} */
                                    style={{backgroundColor:"#313131"}}
                                    //className={rootClassName}
                                >

                                    <PortletHeader className={classes.header}
                                    >
                                        <PortletLabel
                                            /*  icon={<DevicesIcon />} */

                                            variant="h5"
                                            title={"Atentus Notificaciones: "+typeNoti}
                                        />

                                        <PortletToolbar>

                                            <IconButton style={{color:'#FFFFFF'}} onClick={handleClose}><ClearIcon/></IconButton>

                                        </PortletToolbar>
                                    </PortletHeader>

                                    <PortletContent className={classes.content}>

                                        <Grid
                                            container
                                            spacing={10}
                                        >


                                            <Grid
                                                item

                                                //style={{border: "1px solid rgb(204, 204, 204)"}}
                                            >
                                                {title}

                                                <div dangerouslySetInnerHTML={{__html: htmlContent}} />

                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            spacing={10}
                                        >
                                            <Grid
                                                item
                                                alignContent={'center'}
                                                xs={4}
                                                //style={{border: "1px solid rgb(204, 204, 204)"}}
                                            >

                                                <SkipPreviousIcon tooltip="adelante" style={classBackBut}  onClick={this.handleOnclickPrevNotif}/>

                                            </Grid>

                                            <Grid
                                                item
                                                xs={4}
                                                //style={{border: "1px solid rgb(204, 204, 204)"}}
                                            >


                                            </Grid>
                                            <Grid
                                                item
                                                xs={4}

                                                //style={{border: "1px solid rgb(204, 204, 204)"}}
                                            >

                                                <SkipNextIcon fontSize="large" tooltip="adelante" style={classNextBut} onClick={this.handleOnclickNextNotif}/>

                                            </Grid>
                                        </Grid>
                                    </PortletContent>
                                    <PortletFooter className={classes.portletFooter} align="right">
                                        <Grid container spacing={9} >
                                            <Grid item><Checkbox
                                                checked={checked}
                                                onChange={this.handleChange}
                                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                            /><Typography variant="span" color={'initial'} style={{color:'white'}}>No volver a mostrar las notificaciones</Typography></Grid>
                                            <Grid item/>
                                            <Grid item/>
                                            <Grid item><Button variant="contained" onClick={this.dispatchSetShowNot}>Aceptar</Button></Grid>
                                        </Grid>
                                    </PortletFooter>
                                </Portlet>
                            </div>
                        </PerfectScrollbar>
                    </Fade>
                </Modal>

            )
        }
        return null


    }
}
export default
compose(withRouter, withStyles(styles))(UserNotification);